
import { defineComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { PortalLoginResponse } from '@/contracts/api/ResponseContracts'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'
import { nuxeoLogin } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'LoginFinish',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        const route = useRoute()
        // Load vuex:
        const store = useStore()

        // Get form data:
        const loginData = store.getters['formData/loginData']

        // Set fields:
        const fields =
        {
            password:
            {
                name: 'password',
                type: 'Input',
                label: 'Password',
                inputType: 'password',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    }
                }
            }
        }
        // Set buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Continue'
            }
        }
        // Handle submission:
        const saveFormData = (formData: FormDataStructure) =>
        {
            nuxeoLogin(loginData.id, formData.password,
            function(response: PortalLoginResponse)
            {
                store.commit('auth/setAuthenticatedUser',
                {
                    id: response.user.id,
                    email: response.user.properties.email.toLowerCase()
                })
                // Store the OAuth token pair from the proxy's JWT-bearer
                // exchange. The access token rides as Authorization: Bearer
                // on authenticated calls so Nuxeo ownership checks (§3.2)
                // run against the real principal; the refresh token is
                // redeemed via the proxy's /auth/refresh when a 401 signals
                // expiry (Q18–Q22 in
                // docs/proposals/irm-questions-register.md).
                store.commit('auth/setTokens',
                {
                    accessToken: response.tokens.accessToken,
                    refreshToken: response.tokens.refreshToken
                })
                if(route.params.redirect !== undefined)
                {
                    router.push({ name: route.params.redirect as string })
                }
                else
                {
                    router.push({ name: 'Account' })
                }
            },
            [
                {
                    code: 404,
                    error: 'HTTP/1.1 401',
                    message: "Wrong Password, please retry or reset password if you've forgotten",
                    field: 'password'
                }
            ])
        }

        // Return data:
        return {
            fields,
            buttons,
            saveFormData
        }
    }
})
